import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import NotificationChannelOverview from '../components/NotificationChannelOverview';
import BreadCrumb from '../../shared/components/BreadCrumb';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import { Typography, Button } from '@material-ui/core';

const OrganizationNotificationChannels = (props: RouteComponentProps<any>) => {
  return (
    <div>
      <Typography
        color="textSecondary"
        gutterBottom={true}
      >
        <BreadCrumb value="Organization" to="/organization/settings" />
        Notification Channels
      </Typography>
      <div className="padding-bottom-15">
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            props.history.push('/organization/notificationchannels/http/add');
          }}
        >
          <AddAlertIcon className="margin-right-8" /> Add Notification Channel
        </Button>
      </div>
      <NotificationChannelOverview />
    </div>
  );
};

export default withRouter(OrganizationNotificationChannels);



// WEBPACK FOOTER //
// ./src/modules/organization/pages/OrganizationNotificationChannels.tsx